export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/f1012b558962cb39_logo%20terbaru%20logo%20pt%20sinar%20al%20mubarokah.jpeg";

export const WA_NUMBER = "6282282800020";
export const WA_DISPLAY = "0822-8280-0020";
export const WA_DEFAULT_MSG =
  "Halo PT. SINAR AL MUBAROKAH, saya tertarik dengan produk kayu & triplek Anda. Mohon info harga dan katalog terbaru.";
export const waLink = (msg = WA_DEFAULT_MSG) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const MAPS_LINK = "https://share.google/CVt7BF9is5ojq3Rlg";
export const REVIEWS_LINK = "https://share.google/eklPAoPEJfOw56fIx";
export const ADDRESS =
  "Jl. Kalibaru Bar. I, RT.2/RW.8, Kali Baru, Kec. Cilincing, Jakarta Utara, DKI Jakarta 14110";
export const MAPS_EMBED =
  "https://maps.google.com/maps?q=Jl.%20Kalibaru%20Barat%20I%2C%20Kali%20Baru%2C%20Cilincing%2C%20Jakarta%20Utara%2014110&z=16&output=embed";

export const HERO_BG =
  "https://images.unsplash.com/photo-1787422429898-709636d27d1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxwbHl3b29kJTIwdGltYmVyJTIwZmFjdG9yeSUyMHdvcmtlciUyMHNhd21pbGx8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
export const FACTORY_IMG =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/6b585c88139eda1a_kiriman%20skala%20kecil.jpeg";

export const PHOTO_IKATAN_KASO =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/e487651c7302a10b_ikatan%20kaso%204x6%20meranti%20bekisting.jpeg";
export const IMG_TRUCK_DELIVERY =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/b56ce02bd8be0a3a_triplek%2012mm%20-%20Salin.jpeg";
export const IMG_MULTIPLEK18 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/ceea52047e9da3a5_KAYU%20%2816%29.jpeg";
export const IMG_MERANTI_MERAH =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/051f291bbeca3ee0_kayu%20kalimantan%20balok.jpeg";
export const IMG_PAPAN_MERANTI =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/039cfcd3fdaa8b44_kayu%20a.jpeg";
export const IMG_TRIPLEK9 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/84e385cb28095e5b_kayu%20f.jpeg";
export const IMG_BALOK_KERAS =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/9c26e48cb65928cd_balok%20super%20untuk%20custom.jpeg";
export const IMG_PHENOLIC =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/cac5ba353755eceb_KAYU%20%286%29.jpeg";
export const IMG_TRIPLEK12COR =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/aa1c5d7bd58739f6_KAYU%20%2827%29.jpeg";
export const IMG_TRIPLEK18 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/a483f39dd02d4a9c_KAYU%20%2812%29.jpeg";
export const IMG_KAMPAR =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/f3520fa22e8a52cc_KAYU%20%2825%29.jpeg";
export const IMG_KAYU5X10 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/da7f33ae3a1331b6_KAYU%20%2819%29.jpeg";
export const IMG_TRIPLEK8 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/e40e7dfe91d30057_multiplek%20kirim%20proyek.jpeg";
export const IMG_DOLKEN =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/b4ae174343d0a110_KAYU%20%2810%29.jpeg";
export const IMG_TRIPLEK6 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/1f26c633b8821a53_kayu%20sima%20%283%29.jpeg";
export const IMG_ULIN =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/c2e08f8bd910c9db_kayu%203.jpeg";
export const IMG_IKATAN57 =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/6e9343e539923924_Kayu%20Ikatan%20untuk%20proyelk.jpeg";
export const IMG_KASO_SUPER =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/785e5ab4a83bdbc3_balok%205x10%2C%20a.jpeg";
export const IMG_BENGKIRAI =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/6578534549dd2862_kayu%20bengkirai%20tanduk.jpeg";
export const IMG_MC_LOKAL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/d3b51bafa2ea999a_kayu%20sima%20%285%29.jpeg";

export const FACTORY_SLIDES = [
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/63b8ff30f25ba126_kayu%20kaso%20proyek.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/0b15a9d10801ca5d_KAYU%20%285%29.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/d3ca57cb2bb49ca8_reng%202x3%20dan%203x4.jpeg",
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sinar-kayu-triplek/artifacts/71a7801ecf44a407_kayu%20ulin%20cv%20sinar%20al%20mubarokah.jpeg",
];

export const THEMES = [
  { id: "emerald-gold", name: "Biru Laut & Emas", swatch: "#0A2A43", ring: "#B8860B" },
  { id: "teak-amber", name: "Jati & Amber", swatch: "#3D2012", ring: "#E5B869" },
  { id: "slate-gold", name: "Arang & Emas", swatch: "#1A1D20", ring: "#D4AF37" },
  { id: "royal-navy", name: "Biru Eksekutif", swatch: "#0A192F", ring: "#F5D061" },
];

export const KEYWORDS = [
  "distributor triplek murah",
  "jual kayu meranti berkualitas",
  "grosir kayu jati jakarta",
  "supplier blockboard multiplek",
  "pabrik kayu olahan indonesia",
  "jual kayu sengon grosir",
  "distributor multiplek melamin",
  "harga triplek 18mm murah",
  "distributor kayu mahoni oven",
  "jual papan kayu kampar",
  "grosir balok kayu bangkirai",
  "supplier kayu veneer premium",
  "distributor kayu MDF jakarta",
  "jual triplek cor coring murah",
  "grosir kayu konstruksi proyek",
  "distributor kayu lapis indonesia",
  "jual papan kayu jati perhutani",
  "supplier kayu olahan proyek bangunan",
  "grosir kayu lis kayu profil",
  "distributor triplek phenolic murah",
];

export const CATEGORIES = ["Semua", "Triplek & Multiplek", "Kayu Olahan Solid", "Harga Kayu Murah"];

const IMG_A =
  "https://images.unsplash.com/photo-1590635022668-81cc8696a19d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHx3b29kJTIwZ3JhaW4lMjB0ZXh0dXJlJTIwbHVtYmVyJTIwdGltYmVyJTIwcGxhbmtzJTIwc3RhY2t8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
const IMG_B =
  "https://images.unsplash.com/photo-1628229894555-21320be9a9c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHx3b29kJTIwZ3JhaW4lMjB0ZXh0dXJlJTIwbHVtYmVyJTIwdGltYmVyJTIwcGxhbmtzJTIwc3RhY2t8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
const IMG_C =
  "https://images.unsplash.com/reserve/K9PZheO1RSiNMMP1ptsl_wood.jpg?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHx3b29kJTIwZ3JhaW4lMjB0ZXh0dXJlJTIwbHVtYmVyJTIwdGltYmVyJTIwcGxhbmtzJTIwc3RhY2t8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
const IMG_D =
  "https://images.unsplash.com/photo-1694455448553-b1a05121eb0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHx3b29kJTIwZ3JhaW4lMjB0ZXh0dXJlJTIwbHVtYmVyJTIwdGltYmVyJTIwcGxhbmtzJTIwc3RhY2t8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
const IMG_E =
  "https://images.unsplash.com/photo-1589939705384-5185137a7f0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxwbHl3b29kJTIwdGltYmVyJTIwZmFjdG9yeSUyMHdvcmtlciUyMHNhd21pbGx8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";
const IMG_F =
  "https://images.unsplash.com/photo-1787422429939-8b628fa88e3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxwbHl3b29kJTIwdGltYmVyJTIwZmFjdG9yeSUyMHdvcmtlciUyMHNhd21pbGx8ZW58MHx8fHwxNzkxODE5NTkzfDA&ixlib=rb-4.1.0&q=85";

export const PRODUCTS = [
  { id: 1, title: "Multiplek Meranti 18mm Full Sanded", keyword: "distributor triplek murah", category: "Triplek & Multiplek", specs: "1220 x 2440 mm | Grade A Premium | Core Meranti Solid", description: "Multiplek standar industri dengan ketahanan tinggi terhadap benturan dan kelembaban.", image: IMG_MULTIPLEK18, tag: "Best Seller" },
  { id: 2, title: "Meranti Merah", keyword: "jual kayu meranti berkualitas", category: "Kayu Olahan Solid", specs: "Kaso & Balok 4x6, 5x10 cm | Oven | Panjang 4 Meter", description: "Kayu meranti merah pilihan dengan serat padat dan warna kemerahan khas untuk kusen, rangka atap, dan konstruksi.", image: IMG_MERANTI_MERAH, tag: "Pilihan Kontraktor" },
  { id: 3, title: "Papan Kayu Meranti", keyword: "grosir kayu jati jakarta", category: "Kayu Olahan Solid", specs: "Tebal 2-3 cm x Lebar 20-30 cm x 4 m | Serat Halus", description: "Papan meranti olahan mesin berpermukaan halus untuk papan tangga, ambalan, dan panel dinding.", image: IMG_PAPAN_MERANTI, tag: "Super Premium" },
  { id: 4, title: "Triplek 9mm MC", keyword: "supplier blockboard multiplek", category: "Triplek & Multiplek", specs: "1220 x 2440 mm x 9mm | Core Meranti Campuran (MC)", description: "Triplek 9mm core MC yang ringan dan mudah dipasang untuk plafon, sekat ruangan, dan backing mebel.", image: IMG_TRIPLEK9, tag: "Interior Favorit" },
  { id: 5, title: "Balok Kayu Keras", keyword: "grosir balok kayu bangkirai", category: "Kayu Olahan Solid", specs: "6x12, 8x12 cm | Kayu Keras Kelas I/II", description: "Balok kayu keras bangkirai/keruing untuk struktur berat, rangka gudang, dan penopang proyek.", image: IMG_BALOK_KERAS, tag: "Ultra Heavy Duty" },
  { id: 6, title: "Multiplek Phenolic Film Face 18mm", keyword: "distributor triplek phenolic murah", category: "Triplek & Multiplek", specs: "1220 x 2440 mm | Black Film 120g/m2 | WBP Glue", description: "Triplek cor khusus bekisting gedung bertingkat yang dapat dipakai hingga 10-15 kali pakai.", image: IMG_PHENOLIC, tag: "Spesialis Cor" },
  { id: 7, title: "Kayu Ikatan Bekisting", keyword: "jual kayu sengon grosir", category: "Kayu Olahan Solid", specs: "Kaso 4x6, 5x7 cm | Ikat Per 10 Batang | Panjang 4 m", description: "Kaso kayu ikatan siap pakai untuk bekisting cor dan penopang steger proyek — harga per ikat lebih hemat.", image: PHOTO_IKATAN_KASO, tag: "Ekonomis" },
  { id: 8, title: "Triplek 12mm untuk Cor MC", keyword: "distributor kayu MDF jakarta", category: "Triplek & Multiplek", specs: "1220 x 2440 mm x 12mm | Core MC | Lem Kuat WBP", description: "Triplek 12mm khusus bekisting cor yang kokoh menahan tekanan adukan semen dan bisa dipakai berulang.", image: IMG_TRIPLEK12COR, tag: "Presisi Tinggi" },
  { id: 9, title: "Triplek 18mm MC", keyword: "distributor kayu mahoni oven", category: "Triplek & Multiplek", specs: "1220 x 2440 mm x 18mm | Core MC Full", description: "Triplek 18mm tebal dan padat untuk bekisting berat, mebel, dan kebutuhan konstruksi skala besar.", image: IMG_TRIPLEK18, tag: "Export Quality" },
  { id: 10, title: "Papan Kayu Kampar Samarinda Oven", keyword: "jual papan kayu kampar", category: "Kayu Olahan Solid", specs: "3x20x400 cm | Tekstur Serat Lurus Halus", description: "Papan kayu kampar tahan kelembaban tinggi untuk kusen pintu & tangga rumah mewah.", image: IMG_KAMPAR, tag: "Favorit Arsitek" },
  { id: 11, title: "Kayu 5x10x4", keyword: "supplier kayu veneer premium", category: "Kayu Olahan Solid", specs: "5x10 cm x Panjang 4 m | Oven Kering", description: "Kayu ukuran 5x10 panjang 4 meter serbaguna untuk rangka plafon, kusen, dan struktur ringan.", image: IMG_KAYU5X10, tag: "Luxury Finish" },
  { id: 12, title: "Triplek 8mm MC", keyword: "jual triplek cor coring murah", category: "Triplek & Multiplek", specs: "1220 x 2440 mm x 8mm | Core MC", description: "Triplek 8mm ekonomis untuk plafon, partisi, dan pelapis dinding interior.", image: IMG_TRIPLEK8, tag: "Hemat Proyek" },
  { id: 13, title: "Dolken Gelam", keyword: "grosir kayu konstruksi proyek", category: "Kayu Olahan Solid", specs: "Diameter 6-10 cm | Panjang 2-4 m | Kayu Gelam Asli", description: "Dolken gelam bulat utuh yang kuat dan tahan air untuk cerucuk pondasi, pagar, dan penahan tanah.", image: IMG_DOLKEN, tag: "Struktur Berat" },
  { id: 14, title: "Triplek 6mm", keyword: "distributor multiplek melamin", category: "Triplek & Multiplek", specs: "1220 x 2440 mm x 6mm | Lentur & Ringan", description: "Triplek 6mm tipis dan fleksibel untuk plafon lengkung, backing mebel, dan kerajinan.", image: IMG_TRIPLEK6, tag: "Top Finish" },
  { id: 15, title: "Kayu Ulin Kalimantan Super Ironwood", keyword: "supplier kayu olahan proyek bangunan", category: "Kayu Olahan Solid", specs: "Papan / Balok | Bebas Lapuk Tahan Air Laut", description: "Kayu besi legendaris Kalimantan yang makin kuat jika terkena air. Ideal untuk dermaga & decking.", image: IMG_ULIN, tag: "Abadi Tahan Air" },
  { id: 16, title: "Kayu Ikatan 5x7x4 Bekisting", keyword: "grosir kayu lis kayu profil", category: "Kayu Olahan Solid", specs: "5x7 cm x 4 m | Per Ikat | Siap Kirim", description: "Kaso 5x7 panjang 4 meter per ikatan, pilihan hemat kontraktor untuk bekisting dan steger proyek.", image: IMG_IKATAN57, tag: "Profil Detail" },
  { id: 17, title: "Kayu Kaso Ikatan Super", keyword: "distributor kayu lapis indonesia", category: "Harga Kayu Murah", specs: "Ukuran Kayu 4x6x4 | Harga Murah", description: "Macam-macam kayu lengkap dan berbagai jenis ready stock di gudang.", image: IMG_KASO_SUPER, tag: "Serbaguna" },
  { id: 18, title: "Kayu Bengkirai Tanduk", keyword: "jual papan kayu jati perhutani", category: "Kayu Olahan Solid", specs: "Ukuran Campur Tanduk | Kayu Keras Kelas I", description: "Potongan kayu bengkirai tanduk super keras untuk kebutuhan khusus proyek, bantalan, dan kerajinan.", image: IMG_BENGKIRAI, tag: "Outdoor Floor" },
  { id: 19, title: "Custom Ukuran Sesuai Kebutuhan", keyword: "harga triplek 18mm murah", category: "Kayu Olahan Solid", specs: "Potong Sesuai Pesanan | Semua Jenis Kayu", description: "Terima potong dan olahan kayu custom sesuai ukuran kebutuhan proyek Anda — kirim spesifikasinya via WhatsApp.", image: IMG_E, tag: "Mewah & Praktis" },
  { id: 20, title: "Kayu MC Lokal Proyek Murah", keyword: "pabrik kayu olahan indonesia", category: "Kayu Olahan Solid", specs: "Ukuran Standar Proyek | Harga Grosir", description: "Kayu MC lokal ekonomis untuk kebutuhan proyek skala besar dengan harga paling bersaing.", image: IMG_MC_LOKAL, tag: "Aesthetic Wood" },
];

export const TESTIMONIALS = [
  {
    name: "Agung Ramdani",
    role: "Pelanggan Repeat Order — Balaraja",
    photo: IMG_TRUCK_DELIVERY,
    text: "Udah beberapa kali repeat order jati belanda, kayunya selalu sesuai pesanan. Pengiriman lancar sampai ke Balaraja.",
  },
  {
    name: "Tata Cika",
    role: "Ulasan Google Maps",
    photo: IMG_PAPAN_MERANTI,
    text: "Terima kasih pak, kayunya sesuai pesanan.",
  },
  {
    name: "Alfonso Aristokra",
    role: "Ulasan Google Maps",
    photo: IMG_TRIPLEK8,
    text: "Pelayanan luar biasa ramah, harga bersahabat.",
  },
  {
    name: "Andre Drean",
    role: "Ulasan Google Maps",
    photo: IMG_KAYU5X10,
    text: "Terima kasih, kayunya berkualitas tinggi.",
  },
];

export const PRICES = {  1: "Rp 285.000/lembar",
  2: "4x6x4: Rp 27.000/batang · 5x10x4: Rp 57.000/batang",
  3: "Rp 4.200.000/m3",
  4: "Rp 165.000/lembar",
  5: "Rp 95.000/batang",
  6: "Rp 310.000/lembar",
  7: "Rp 240.000/ikat",
  8: "Rp 210.000/lembar",
  9: "Rp 265.000/lembar",
  10: "Rp 4.500.000/m3",
  11: "Rp 55.000/batang",
  12: "Rp 150.000/lembar",
  13: "Rp 18.000/batang",
  14: "Rp 115.000/lembar",
  15: "Rp 16.500.000/m3",
  16: "Rp 300.000/ikat",
  17: "Rp 220.000/ikat",
  18: "Rp 5.500.000/m3",
  19: "Harga custom",
  20: "Rp 2.100.000/m3",
};

export const CALC_ITEMS = [
  { id: "multiplek18", name: "Multiplek Meranti 18mm (per lembar 1220x2440)", mode: "sheet", price: 285000 },
  { id: "meranti", name: "Kayu Meranti Oven (per m3)", mode: "volume", price: 3850000 },
  { id: "jati", name: "Kayu Jati Perhutani Grade A (per m3)", mode: "volume", price: 15500000 },
  { id: "sengon", name: "Kayu Sengon Olahan (per m3)", mode: "volume", price: 1950000 },
];

export const formatIDR = (n) =>
  new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    maximumFractionDigits: 0,
  }).format(n);

export const navigateTo = (path) => {
  window.history.pushState({}, "", path);
  window.dispatchEvent(new Event("app:navigate"));
};

export const priceLabel = (id) => {
  const p = PRICES[id];
  return p && p.startsWith("Rp") ? `mulai ${p}` : p;
};
